// extracted by mini-css-extract-plugin
export default {"button":"onfido-sdk-ui-ActiveVideo-Button-button"};